import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import ErrorIcon from "@mui/icons-material/ErrorOutline" 

const ForceLogoutModalView = (props) => {
    return (
        <Dialog open={props.open} onClose={props.close} fullWidth maxWidth="sm"
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 4
                },
            }}
        >
            <DialogContent sx={{pb:0}}>
                <Box sx={{display:"flex", alignItems:"center", flexDirection:"column", justifyContent:"center"}}>
                <ErrorIcon color="error"/>
                <Typography color="error" variant="body">Your session expired.</Typography>
                <Typography variant="caption" sx={{opacity:.6}}>Please signin again.</Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.close}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ForceLogoutModalView;